let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("88BSo")).then(() => parcelRequire('4RFM5'));